import { Circle, LifeBuoy, MessageSquare, Headphones } from "react-feather";

import {
  TICKETS_LIST_PATH,
  FEEDBACK_LIST_PATH,
  HELPDESK_LIST_PATH,
} from "@src/views/apps/support/paths";
import { navPerm } from "../navPermissions";
import { PERMISSION_MODULE } from "@src/utility/permissions/modulePermissions";

export default [
  {
    header: "Support",
  },
  {
    id: "support",
    title: "Support",
    icon: <LifeBuoy size={20} />,
    children: [
      {
        id: "support-tickets",
        title: "Support Tickets",
        icon: <Circle size={12} />,
        navLink: TICKETS_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.TICKET),
      },
      {
        id: "feedback",
        title: "Feedback",
        icon: <MessageSquare size={12} />,
        navLink: FEEDBACK_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.FEEDBACK),
      },
      {
        id: "helpdesk",
        title: "Helpdesk",
        icon: <Headphones size={12} />,
        navLink: HELPDESK_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.HELPDESK),
      },
    ],
  },
];
